// import axios from '@/lib/axios';
import config from './config';

function getDetailbandwidthPackages(params) {
	return Ajax.get(config.detailBandwidthPackages, params);	
}
function modifyBandwidthPackagesName(params) {
	return Ajax.post(config.detailBandwidthPackages, params);  
}
function getListElasticIps(params) {
	return Ajax.get(config.listElasticIps, params);  
}
export {
  getDetailbandwidthPackages,
  modifyBandwidthPackagesName,
  getListElasticIps
};


// WEBPACK FOOTER //
// ./src/api/sbw/detail/actions.js